<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['amazon-s3']">
            <mat-icon matListIcon [routerLink]="['amazon-s3']">
              <fa-icon icon="cloud" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['amazon-s3']">{{ 'labels.heading.S3 Amazon External Service' | translate }}</h4>
            @if (!arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <p matLine [routerLink]="['amazon-s3']">
                {{ 'labels.text.S3 Amazon Service Configuration' | translate }}
              </p>
            }
          </mat-list-item>

          <mat-list-item [routerLink]="['sms']">
            <mat-icon matListIcon [routerLink]="['sms']">
              <fa-icon icon="comment-alt" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['sms']">{{ 'labels.heading.SMS External Service' | translate }}</h4>
            @if (!arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <p matLine [routerLink]="['sms']">
                {{ 'labels.text.SMS Service Configuration' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['email']">
            <mat-icon matListIcon [routerLink]="['email']">
              <fa-icon icon="envelope" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['email']">{{ 'labels.heading.Email External Service' | translate }}</h4>
            @if (!arrowBooleans[2]) {
              <fa-icon (click)="arrowBooleansToggle(2); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[2]) {
              <fa-icon (click)="arrowBooleansToggle(2); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[2]) {
              <p matLine [routerLink]="['email']">
                {{ 'labels.text.Email Service Configuration' | translate }}
              </p>
            }
          </mat-list-item>

          <mat-list-item [routerLink]="['notification']">
            <mat-icon matListIcon [routerLink]="['notification']">
              <fa-icon icon="bell" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['notification']">
              {{ 'labels.heading.Notification External Service' | translate }}
            </h4>
            @if (!arrowBooleans[3]) {
              <fa-icon (click)="arrowBooleansToggle(3); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[3]) {
              <fa-icon (click)="arrowBooleansToggle(3); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[3]) {
              <p matLine [routerLink]="['notification']">
                {{ 'labels.text.Notification Service Configuration' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>
